import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import orderReducer from './slices/orderSlice';
import userReducer from './slices/userSlice';
import paymentMethodReducer from './slices/paymentMethodSlice';
import transactionReducer from './slices/transactionSlice';
import modalReducer from './slices/modalSlice';
import filterReducer from './slices/filterSlice';
import settingsReducer from './slices/settingsSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const rootReducer = combineReducers({
  auth: authReducer,
  order: orderReducer,
  user: userReducer,
  paymentMethod: paymentMethodReducer,
  transaction: transactionReducer,
  modal: modalReducer,
  filter: filterReducer,
  settings: settingsReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'], // only persist auth
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store; 